import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-toc-dialog',
  templateUrl: './toc.component.html',
  styleUrls: ['./toc.component.scss']
})
export class TocComponent implements OnInit {
  public prompt: string;
  public message: string;
  tocForm = new FormGroup ({
    agreedCheckbox: new FormControl({value: false, disabled: true})
  });

  constructor(public dialogRef: MatDialogRef<TocComponent>) { }

  scrollEvent(event) {
    if (event.bottom) {
      this.tocForm.controls.agreedCheckbox.enable();
    }
  }

  ngOnInit() {
  }

  agreed(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
